// @ts-nocheck
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

import * as React from "react";
import { connect } from "react-redux";

/* Starter Custom Code */
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";
/* Starter Custom Code */

// Store Custom Code
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            realTimeText: {
                /* Store Custom Code */
                color: "text.main",
                css: css`
                    display: inline-block;
                    text-align: left;
                    min-width: ${pxToRem(25)};
                    font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                    font-size: ${({ theme }) => theme.design.typography.size.large};
                    &::after {
                        overflow: hidden;
                        display: inline-block;
                        vertical-align: bottom;
                        animation: ellipsis steps(4, end) 900ms infinite 1s;
                        content: "\\2026";
                        width: 0;
                    }

                    @keyframes ellipsis {
                        to {
                            width: 1.25em;
                        }
                    }
                `,
            },
            priceText: {
                color: "text.main",
                css: css`
                    ${({ theme }) => `
                    font-size: ${theme.design.typography.size.large};
                    font-weight: ${theme.design.typography.weight.bold};
                `}
                `,
            },
        },

        wrapper: {
            css: css`
                ${x => spacingStyles(x.theme.design.product.detail.contentSpacing, null)}
            `,
        },
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    return (
        <ProductPrice
            product={productContext}
            showLabel={false}
            showSavings={true}
            showSavingsAmount={productSettings.showSavingsAmount}
            showSavingsPercent={productSettings.showSavingsPercent}
            extendedStyles={styles.productPrice}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
